import React from 'react';
import Cookie from 'react-cookie';
import { connect } from 'react-redux';

import CookieNames from '../models/enums/CookieNames';
import { getCurrentPage } from '../selectors/page';
import { RootDispatch, RootState } from '../store';
import { Pages } from '../types';
import { AccessCodeForm, Invalid, RequestAccess } from './Auth';
import Messenger from './Messenger';
import DotsIndicator from './DotsIndicator';
import AuthErrorModal from './AuthErrorModal';

export function PatientFacing({
  currentPage,
  init,
}: {
  currentPage?: string;
  init: (payload: unknown) => void;
}) {
  const MAX_ATTEMPTS = 5;
  const authErrCount = parseInt(Cookie.load(CookieNames.AUTH_ERR_COUNT));

  switch (currentPage) {
    case Pages.Initial:
      if (authErrCount === MAX_ATTEMPTS) {
        return <AuthErrorModal />;
      }
      init('');
      return <DotsIndicator color="#65659e" />;
    case Pages.InputAccessCode:
      // https://tigertext.atlassian.net/browse/TMG-837
      // @ts-expect-error
      return <AccessCodeForm />;
    case Pages.Invalid:
      return <Invalid />;
    case Pages.Loading:
      return <DotsIndicator color="#65659e" />;
    case Pages.Messenger:
      return <Messenger />;
    case Pages.RequestAccessCode:
      return <RequestAccess />;
    case Pages.TooManyRequests:
      return <AuthErrorModal />;
    default:
      throw new Error('Invalid Page');
  }
}

const mapState = (state: RootState) => ({
  currentPage: getCurrentPage(state),
});

const mapDispatch = ({ currentPage: { init } }: RootDispatch) => ({
  init,
});

// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
const App = connect(mapState, mapDispatch)(PatientFacing);

export default App;
